// extracted by mini-css-extract-plugin
module.exports = {"bind-form-button":"_1oEgODB3I6ls_xCLjqbAuq"};